module.exports = __webpack_public_path__ + "media/images/google-7ca3a2f4ed8613a62ae8082278bf556d.png";